import React, { useContext, useReducer } from "react";

import { Box, Tooltip } from "@mui/material";
import { api } from "../../../services/api";
import toast from "react-hot-toast";
import { lockedReducer } from "../../Utils/reducers";
import { externalComponent } from "../../AppRoutes";
import ColorButton from "../../Buttons/ColorButton";
import { MobileDatePicker } from "@mui/x-date-pickers";
import ReplyIcon from "@mui/icons-material/Reply";
import dayjs from "dayjs";
import { number2dayweek } from "../../Utils/dayjsptbrhelper";
import MegaAutoComplete from "../../Utils/megaautocomplete";
import ReportTable from "../report_table";
import PrintToPDF from "../../Utils/Print2Pdf";

const searchURL = '/reportsaux/'
const url = "/reports/serviceperiodicity/";

const columns = [
  { field: 'os_sequence', headerName: 'N° OS', width: '7rem', count: true },
  { field: 'client', headerName: 'Cliente', width: '15rem' },
  { field: 'phone_number', headerName: 'Telefone', width: '10rem' },
  {
    field: 'datetime', headerName: 'Data da OS', width: '7rem',
    valueGetter: ({ value }) => dayjs(value).format('DD/MM/YYYY')
  },
  { field: 'service', headerName: 'Serviço', flex: 1 },
  {
    field: 'return_date', headerName: 'Retorno', width: '7rem',
    valueGetter: ({ value }) => dayjs(value).format('DD/MM/YYYY')
  },
]

const generate = async (state, setState, setLoader) => {
  setLoader(true)
  const res = await api.post(url, {
    return_date__gte: state.return_date__gte.format('YYYY-MM-DD'),
    return_date__lte: state.return_date__lte.format('YYYY-MM-DD'),
    client: state.client?.id || null,
    service: state.service?.id || null,
  })

  if (res.status !== 200) {
    toast.error(`Falha ao gerar o relatório. Motivo: ${res.error}`)
  }
  else {
    if (res.data.length === 0) toast.success('Nenhuma OS atingiu a periodicidade do serviço no período')
    setState({ rows: res.data })
  }
  setLoader(false)
}

const ServicePeriodicity = () => {
  const { setLoader } = useContext(externalComponent);

  const [state, setState] = useReducer(lockedReducer, {
    rows: [],
    return_date__gte: dayjs(),
    return_date__lte: dayjs(),
    client: '',
    service: '',
  });

  const period = state.return_date__gte.isSame(state.return_date__lte, 'day') ?
    `em ${state.return_date__gte.format('DD/MM/YYYY')}` :
    `entre ${state.return_date__gte.format('DD/MM/YYYY')} e ${state.return_date__lte.format('DD/MM/YYYY')}`

  return (
    <>
      <Box className="information-table">
        <Box className='header'>
          <Box className='left'>
            <Box className='item-profile-row' sx={{ gap: '1rem', display: 'flex', flexWrap: 'wrap' }}>
              <Tooltip title='Voltar'>
                <ColorButton
                  className='profile-save-button minimized'
                  onClick={() => window.backtobase()}
                >
                  <ReplyIcon />
                </ColorButton>
              </Tooltip>

              <MobileDatePicker
                size='small'
                label='Retorno de'
                value={dayjs(state.return_date__gte)}
                format='DD/MM/YYYY'
                sx={{ background: 'white' }}
                onChange={(e) => { setState({ 'return_date__gte': e }) }}
                slotProps={{ textField: { size: 'small' } }}
                dayOfWeekFormatter={(n, date) => number2dayweek[date.$W]}
                ampm={false}
              />

              <MobileDatePicker
                size='small'
                label='Retorno até'
                value={dayjs(state.return_date__lte)}
                format='DD/MM/YYYY'
                sx={{ background: 'white' }}
                onChange={(e) => { setState({ 'return_date__lte': e }) }}
                slotProps={{ textField: { size: 'small' } }}
                dayOfWeekFormatter={(n, date) => number2dayweek[date.$W]}
                ampm={false}
              />
              <MegaAutoComplete
                value={state.client}
                onChange={(data) => setState({ client: data })}
                noOptionsText={`Digite para procurar clientes`}
                timeoutUrl={searchURL + 'clients/'}
                timeoutParam={'name'}
                label={'Clientes'}
              />
              <MegaAutoComplete
                value={state.service}
                onChange={(data) => setState({ service: data })}
                noOptionsText={`Digite para procurar serviços`}
                timeoutUrl={searchURL + 'services/'}
                timeoutParam={'name'}
                label={'Serviço'}
              />
              <ColorButton
                sx={{ height: '2.5rem' }}
                onClick={() => { generate(state, setState, setLoader) }}
              >Gerar relatório</ColorButton>
              {state.rows.length > 0 &&
                <ColorButton onClick={() => { PrintToPDF('report-main-screen', null, 'Relatório') }}
                  sx={{ height: '2.5rem' }}>
                  Imprimir relatório
                </ColorButton>}
            </Box>

          </Box>
        </Box>
        <Box id='report-main-screen' className="report-main-screen">
          <ReportTable
            title={`OSs com retorno do serviço previsto ${period}${state?.client?.label ? ` - Cliente - ${state.client.label}` : ''}${state?.service?.label ? ` - Serviço - ${state.service.label}` : ''}`}
            rows={state.rows}
            columns={columns}
          />
        </Box>
      </Box>
    </>
  );
};

export default ServicePeriodicity;
